export default (state) => ({
  ...state.importers.meta,
  total: Number(state.importers.meta.total),
  pages: Number(state.importers.meta.pages),
})
